import { useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../Dashboard/Header";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  TextField,
  Box,
  Typography,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";

import Swal from "sweetalert2";
import ShowVoucherDetails from "./ShowVoucherDetails";

const PREFERENCE_KEY = "infiniteAppUserPreferences";
const SELECTED_VCH_TYPE_KEY = "infiniteAppSelectedVchType";

// Add CSS for SweetAlert container positioning
const style = document.createElement("style");
style.textContent = `
  .swal-container-show-voucher-details {
    position: fixed;
    z-index: 10000;
  }
  
  .swal-container-primary-approval-table {
    position: fixed;
    z-index: 10000;
  }
`;
document.head.appendChild(style);

//Local Variables
const VoucherTable = () => {
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  // const Username = localStorage.getItem("username");
  const [pageSize, setPageSize] = useState(20);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [PriVchs, setVouchers] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openPeriod, setOpenPeriod] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [VchTypes, setVchTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  // Load saved voucher type from localStorage
  const savedVchType = localStorage.getItem(SELECTED_VCH_TYPE_KEY);
  const [vchTypeName, setvchTypeName] = useState(savedVchType || "");

  const handleVchTypeChange = (event) => {
    const value = event.target.value;
    setvchTypeName(value);
    // Save to localStorage
    localStorage.setItem(SELECTED_VCH_TYPE_KEY, value);
    fetchData(value);
  };

  // Clear saved voucher type when component unmounts (optional)
  // useEffect(() => {
  //   return () => {
  //     // If you want to clear the selection when leaving the page completely
  //     // localStorage.removeItem(SELECTED_VCH_TYPE_KEY);
  //   };
  // }, []);

  useEffect(() => {
    fetchData();
  }, []);

  //function to fetch Primary Approval voucher list
  const fetchData = async (selectedType = vchTypeName) => {
    setIsLoading(true);
    const privchbody = {
      cmpid: cmpid,
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/vchPrimaryList",
        privchbody,
        {
          headers: { Authorization: token },
        }
      );
      const arrayData = Object.values(response.data);
      // console.log("pri vch List  ", arrayData);

      // Sort voucher data by voucher number in ascending order initially
      const sortedArrayData = arrayData.sort((a, b) => {
        // Convert voucher numbers to numbers for proper numerical sorting
        const vchNumA = parseInt(a.vch_number) || 0;
        const vchNumB = parseInt(b.vch_number) || 0;
        return vchNumA - vchNumB;
      });

      //  Get unique Vch Type
      const uniqueVchtype = sortedArrayData.filter(
        (item, index, self) =>
          index === self.findIndex((obj) => obj.vch_type === item.vch_type)
      );
      setVchTypes(uniqueVchtype);

      // If no selected type, show all vouchers
      if (!selectedType) {
        setVouchers(sortedArrayData);
      } else {
        // Check if the saved voucher type exists in the current data
        const typeExists = sortedArrayData.some(
          (row) => row.vch_type === selectedType
        );
        
        if (typeExists) {
          const vchtypeFlt = sortedArrayData.filter(
            (row) => row.vch_type === selectedType
          );
          setVouchers(vchtypeFlt);
          
          // If selected type has no data, check other available types
          if (vchtypeFlt.length === 0 && uniqueVchtype.length > 0) {
            // Find the first available voucher type
            const availableType = uniqueVchtype.find(type => {
              const filteredData = sortedArrayData.filter(row => row.vch_type === type.vch_type);
              return filteredData.length > 0;
            });
            
            if (availableType) {
              // Auto-switch to available voucher type
              const newVchType = availableType.vch_type;
              const newFilteredData = sortedArrayData.filter(
                (row) => row.vch_type === newVchType
              );
              setVouchers(newFilteredData);
              setvchTypeName(newVchType);
              localStorage.setItem(SELECTED_VCH_TYPE_KEY, newVchType);
            }
          }
        } else {
          // If saved type doesn't exist, show all and clear the selection
          setVouchers(sortedArrayData);
          setvchTypeName("");
          localStorage.removeItem(SELECTED_VCH_TYPE_KEY);
        }
      }
      ConfigVchDet(sortedArrayData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // =================================================

  const [vchdata, setvchdata] = useState([]);

  const ConfigVchDet = async (PriVch) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/voucherType`,
        { cmpid },
        { headers: { Authorization: token } }
      );
      const voucherstypes = response.data.vchTypeMap[0].vchType;
      // console.log('voucherstypes',voucherstypes)
      const selectedConfigs = voucherstypes
        .map((vch) => {
          const match = PriVch.find((sec) => sec.vch_type === vch.vchTypeName);
          return match ? vch : null;
        })
        .filter(Boolean);

      //  console.log("Selected Configs:", selectedConfigs[0]);

      setvchdata(selectedConfigs[0]);
    } catch (err) {
      console.log(err);
    }
  };

  // Function to show SweetAlert above specific container
  const showSweetAlert = (config, containerId = null) => {
    // Get the container element
    let containerElement = null;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    }

    const swalConfig = {
      ...config,
      customClass: {
        popup: "small-alert",
        container: containerId ? `swal-container-${containerId}` : "",
      },
    };

    // If container element exists, calculate position
    if (containerElement) {
      const rect = containerElement.getBoundingClientRect();
      swalConfig.position = "top";
      swalConfig.grow = "row";
    }

    return Swal.fire(swalConfig);
  };

  // Function to handle approval from ShowVoucherDetails
  const handleVoucherApprove = async (vchId) => {
    const vchsignApp = {
      vchLevel: vchdata.approvalConfig[0].level,
      vchid: vchId,
    };

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + `/approvalModule/vchPrimaryUpdate`,
        vchsignApp,
        {
          headers: { Authorization: token },
        }
      );

      // Remove the voucher from local state immediately
      setVouchers(prev => prev.filter((vch) => vch.vch_id !== vchId));
      
      // Success Alert - Show above ShowVoucherDetails
      showSweetAlert(
        {
          title: "Approved!",
          text: "Approved successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#28a745",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        },
        "show-voucher-details"
      ).then((result) => {
        if (result.isConfirmed) {
          // Check if we need to switch voucher types
          fetchData();
        }
      });
    } catch (error) {
      // Error alert - Show above ShowVoucherDetails
      showSweetAlert(
        {
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "Close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
        },
        "show-voucher-details"
      );
    }
  };

  // Function to handle rejection from ShowVoucherDetails
  const handleVoucherReject = async (vchId, rejectReason) => {
    // Primary approval doesn't have reject functionality, so this won't be called
    console.log("Reject not supported for primary approval");
  };

  //approval function for single Voucher in table
  const handleApproval = async (id) => {
    const vchsignApp = {
      vchLevel: vchdata.approvalConfig[0].level,
      vchid: id,
    };

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + `/approvalModule/vchPrimaryUpdate`,
        vchsignApp,
        {
          headers: { Authorization: token },
        }
      );
      
      // Remove the voucher from local state immediately
      setVouchers(prev => prev.filter((vch) => vch.vch_id !== id));
      
      // Success Alert - Show above primary-approval table
      showSweetAlert(
        {
          title: "Approved!",
          text: "Approved successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#28a745",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        },
        "primary-approval-table"
      ).then((result) => {
        if (result.isConfirmed) {
          // Check if we need to switch voucher types
          fetchData();
        }
      });
    } catch (error) {
      //error alert - Show above primary-approval table
      showSweetAlert(
        {
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "Close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
        },
        "primary-approval-table"
      );
    }
  };

  //function for bulk approval
  const handleApprovalAll = async () => {
    const selectedVoucherIds = rows
      .filter((row) => selectedIds.includes(row.id))
      .map((row) => row.id);
    const formattedArray = selectedVoucherIds.map((id) => ({
      vchid: id,
      vchLevel: vchdata.approvalConfig[0].level,
    }));

    if (formattedArray.length === 0) {
      showSweetAlert(
        {
          title: "Warning",
          text: "Please select check box for Multiple Approval.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#f0ad4e",
          width: "300px",
          padding: "1em",
        },
        "primary-approval-table"
      );
      return;
    }

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/allVchPrimaryUpdate",
        formattedArray,
        {
          headers: { Authorization: token },
        }
      );
      
      // Remove approved vouchers from local state
      setVouchers(prev => prev.filter(vch => !selectedVoucherIds.includes(vch.vch_id)));
      
      // Success Alert - Show above primary-approval table
      showSweetAlert(
        {
          title: "Approved!",
          text: "Approved successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#28a745",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        },
        "primary-approval-table"
      ).then((result) => {
        if (result.isConfirmed) {
          // Check if we need to switch voucher types
          fetchData();
        }
      });
    } catch (error) {
      //error alert - Show above primary-approval table
      showSweetAlert(
        {
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "Close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
        },
        "primary-approval-table"
      );
    }
  };

  const convertDate = (dateString) => {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${day} /${month} /${year}`;
  };

  // Filter data  initial state
  const [filteredData, setFilteredData] = useState([]); // initial data

  const handleApply = () => {
    let result = PriVchs;
    // console.log("Original Data", result);

    if (fromDate || toDate) {
      //vchTypeName
      result = result.filter((row) => {
        // Convert row.vch_date (YYYYMMDD) into valid Date
        const dateStr = row.vch_date.toString();
        const rowDate = new Date(
          `${dateStr.substring(0, 4)}-${dateStr.substring(
            4,
            6
          )}-${dateStr.substring(6, 8)}`
        );

        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from && to) return rowDate >= from && rowDate <= to;
        if (from) return rowDate >= from;
        if (to) return rowDate <= to;
        return true;
      });
    } else {
      result = PriVchs;
    }

    setFilteredData(result);
    setOpenPeriod(false);
  };

  const DateFilterData = !fromDate && !toDate ? PriVchs : filteredData;

  //rows for vouchers table - sorted by voucher number initially
  const rows = Array.isArray(DateFilterData)
    ? DateFilterData.map((PriVch) => ({
        id: PriVch.vch_id,
        vchDate: convertDate(PriVch.vch_date),
        partyName: PriVch.PartyName,
        vchNumber: PriVch.vch_number,
        vchTypes: PriVch.vch_type,
        vchAmount: PriVch.vch_Amount,
        vchRemark: PriVch.reject_Remark,
      }))
    : [];

  //colums width for primary vouchers table

  const getColumnWidth = (rows, field, header) => {
    const maxLength = Math.max(
      ...rows.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 15;
  };

  const columns = [
    {
      field: "vchDate",
      headerName: "Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "vchDate", "Date"),
    },
    {
      field: "partyName",
      headerName: "Particulars",
      headerAlign: "left",
      align: "left",
      width: Math.min(getColumnWidth(rows, "partyName", "Particulars"), 200),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "vchNumber",
      headerName: "Vch No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "vchNumber", "Vch No") + 50,
      sortable: true,
    },
    {
      field: "vchAmount",
      headerName: "Amount",
      headerAlign: "left",
      align: "left",
      width: getColumnWidth(rows, "vchAmount", " Amount"),
      sortable: true,
    },
    {
      field: "vchTypes",
      headerName: "Vch Types",
      headerAlign: "left",
      align: "left",
      width: Math.min(getColumnWidth(rows, "vchTypes", "Vch Types"), 150),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "vchRemark",
      headerName: "Remarks",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: Math.min(getColumnWidth(rows, "vchRemark", "Remarks"), 150),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "Action",
      headerName: "",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      headerClassName: "sticky-col-header",
      cellClassName: "sticky-col",
      width: 150, // fixed, width
      renderCell: (PriVch) => (
        <Box>
          <Button
            variant="contained"
            color="success"
            startIcon={<VerifiedIcon sx={{ fontSize: 16 }} />}
            type="button"
            style={{ height: 20, fontSize: 15 }}
            onClick={(e) => {
              e.stopPropagation();
              handleApproval(PriVch.id);
            }}
          >
            Approve
          </Button>
        </Box>
      ),
    },
  ];

  //========= code for single voucher data show

  const [openView, setViewOpen] = useState(false);
  const [vchId, setvchId] = useState("");

  const handleCloseShow = () => setViewOpen(false);

  const handleShowData = async (id) => {
    setViewOpen(true);
    setvchId(id);
  };

  return (
    <>
      <ShowVoucherDetails
        openView={openView}
        vchId={vchId}
        handleCloseShow={handleCloseShow}
        showApproveButton={true}
        showRejectButton={false}
        onApprove={handleVoucherApprove}
        onReject={handleVoucherReject}
      />

      {/* show all voucher entry */}
      <Box mt="70px" ml="0px" mr="20px" id="primary-approval-table">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header
            title="Voucher Approval"
            subtitle="Primary Voucher Approval"
          />
          <Box
            gap={2}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Button
              onClick={() => setOpenPeriod(true)}
              variant="contained"
              sx={{
                height: "35px",
                minHeight: "35px",
                backgroundColor: colors.blueAccent[700], // Custom background color
                color: colors.primary[150], // Custom text color
                "&:hover": {
                  backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                  color: colors.primary[150], // Maintain the same text color on hover
                },
              }}
            >
              {!fromDate && !toDate ? (
                <>
                  <span>From :- </span>
                  {PriVchs?.length > 0 && PriVchs[0]?.vch_date
                    ? convertDate(PriVchs[0].vch_date)
                    : "—"}
                </>
              ) : (
                <>
                  <span>From :- </span>
                  {fromDate || "—"},<span>To :- </span>
                  {toDate || "—"}
                </>
              )}
            </Button>
            {/* ============= vch type filter =========== */}
            <FormControl
              variant="outlined"
              sx={{
                minWidth: 200,
                height: "35px",
                minHeight: "35px",
              }}
            >
              <InputLabel
                id="vch-type-label"
                sx={{
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: "translate(14px, 0px) scale(1)", // Fixed positioning
                  "&.Mui-focused, &.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)", // Position when focused/shrunk
                  },
                }}
              >
                Select Vch Type
              </InputLabel>
              <Select
                labelId="vch-type-label"
                value={vchTypeName}
                onChange={handleVchTypeChange}
                label="Select Vch Type"
                sx={{
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  "& .MuiSelect-select": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
              >
                <MenuItem value="">
                  <em>All Voucher Types</em>
                </MenuItem>
                {VchTypes?.map((item, index) => (
                  <MenuItem key={index} value={item.vch_type}>
                    {item.vch_type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* ============================================ */}
            <Button
              variant="contained"
              color="success"
              sx={{
                height: "30px",
                minHeight: "30px",
              }}
              onClick={handleApprovalAll}
            >
              Approve All
            </Button>
          </Box>
        </Box>

        {/* vouchers table  */}
        <Box
          height="81vh"
          sx={{
            "& .MuiDataGrid-root": { 
              border: "none",
              // Ensure consistent borders
              borderBottom: `1px solid ${colors.grey[700]}`
            },
            "& .MuiDataGrid-cell": { 
              border: "none", 
              cursor: "pointer",
              // Add bottom border to cells for horizontal lines
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              borderTop: `1px solid ${colors.grey[700]} !important`,
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // ✅ Add horizontal grid lines to rows as well
            "& .MuiDataGrid-row": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            // ✅ Zoom on hover using a class
            "& .Prezoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
            // ✅ Sticky column styles
            "& .sticky-col-header": {
              position: "sticky",
              right: 0,
              zIndex: 2,
              backgroundColor: colors.blueAccent[700],
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            "& .sticky-col": {
              position: "sticky",
              right: 0,
              zIndex: 1,
              backgroundColor: colors.primary[400],
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            "& .Prezoom-row:hover .sticky-col": {
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          {isLoading ? (
            <Box 
              display="flex" 
              justifyContent="center" 
              alignItems="center" 
              height="100%"
            >
              <Typography>Loading...</Typography>
            </Box>
          ) : rows.length > 0 ? (
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={pageSize}
              onRowClick={(params) => handleShowData(params.row.id)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[20, 50, 100]}
              getRowClassName={() => "Prezoom-row"}
              checkboxSelection
              onSelectionModelChange={(newSelection) =>
                setSelectedIds(newSelection)
              }
              pagination
              rowHeight={30}
              headerHeight={30}
              componentsProps={{
                footer: {
                  sx: {
                    height: 30,
                    minHeight: 30,
                  },
                },
              }}
              sx={{
                "& .MuiDataGrid-virtualScroller": {
                  overflow: "auto",
                },
                // Hide sort icons completely
                "& .MuiDataGrid-menuIcon, & .MuiDataGrid-sortIcon": {
                  opacity: 0,
                  transition: "opacity 0.2s ease-in-out",
                },
                // Show sort icons only on column header hover
                "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon":
                  {
                    opacity: 1,
                  },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "vchNumber",
                      sort: "asc",
                    },
                  ],
                },
              }}
            />
          ) : (
            <Box 
              display="flex" 
              justifyContent="center" 
              alignItems="center" 
              height="100%"
              flexDirection="column"
              gap={2}
            >
              <Typography variant="h6" color="textSecondary">
                No vouchers available for "{vchTypeName || 'selected type'}"
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/*Change Period pop Up Code */}

      <Dialog open={openPeriod} onClose={() => setOpenPeriod(false)}>
        <DialogTitle variant="h2">Change Period</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography sx={{ minWidth: "50px" }}>From :</Typography>
              <TextField
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                size="small"
              />
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography sx={{ minWidth: "50px" }}>To :</Typography>
              <TextField
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                size="small"
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenPeriod(false);
              setFromDate("");
              setToDate("");
            }}
          >
            Cancel
          </Button>{" "}
          <Button
            onClick={handleApply}
            variant="contained"
            sx={{
              backgroundColor: "#EFE17C",
              color: "#000000",
              height: "35px",
              minHeight: "35px",
              "&:hover": {
                backgroundColor: "#E6D669",
                color: "#000000",
              },
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default VoucherTable;